import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { CommonModule } from '@angular/common';
import { DatePickerModule } from 'primeng/datepicker';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { NgModule } from '@angular/core';
import { PanelModule } from 'primeng/panel';
import { PasswordModule } from 'primeng/password';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { ProgressBarModule } from 'primeng/progressbar';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TooltipModule } from 'primeng/tooltip';
import { SelectButtonModule } from 'primeng/selectbutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { TabsModule } from 'primeng/tabs';
import { MenuModule } from 'primeng/menu';
import { FileUploadModule } from 'primeng/fileupload';
import { TreeSelectModule } from 'primeng/treeselect';
import { TreeTableModule } from 'primeng/treetable';
import { PaginatorModule } from 'primeng/paginator';
import { SplitButtonModule, SplitButton } from 'primeng/splitbutton';

import { ServerSearchDirective } from '@card-software/nexus-utilities';

const components = [
  ServerSearchDirective,
  FileUploadModule,
  ToastModule,
  AutoCompleteModule,
  AccordionModule,
  MultiSelectModule,
  SelectButtonModule,
  BreadcrumbModule,
  ButtonModule,
  CardModule,
  ConfirmDialogModule,
  InputGroupAddonModule,
  InputGroupModule,
  CheckboxModule,
  CommonModule,
  DatePickerModule,
  FloatLabelModule,
  InputNumberModule,
  MessageModule,
  InputTextModule,
  PaginatorModule,
  PanelModule,
  PasswordModule,
  SelectModule,
  TableModule,
  TagModule,
  TextareaModule,
  ProgressBarModule,
  ToggleSwitchModule,
  TooltipModule,
  TabsModule,
  MenuModule,
  TreeSelectModule,
  TreeTableModule,
  SplitButtonModule,
  SplitButton,
];

@NgModule({
  declarations: [],
  imports: [...components],
  exports: [...components],
  providers: [],
})
export class PrimengModule {}
